export function getUserInfo() {
    let str = localStorage.getItem('user-info');
    if (!str) {
        return null;
    }
    return JSON.parse(str);
}

export function setUserInfo(data) {
    localStorage.setItem('user-info', JSON.stringify(data));
}
